<template>
  <div class="talent">
    <div class="input">
      <div class="form">
        <div class="input-item">
          <div class="name">{{getIndexData.fixedFieldMap['joinUs.post']}}</div>
          <input type="text" v-model="inputName">
        </div>
        <div class="input-item">
          <div class="name">{{getIndexData.fixedFieldMap['joinUs.comtent']}}</div>
          <textarea name="" id="" cols="30" rows="10" v-model='inputContent'></textarea>
        </div>
        <div class="uploadBtn">
          <div class="uploadImg">
            <img :src="require('@/assets/image/upload.png')" alt="">
          </div>
          <div class="btn" @click="uploadResume">
            {{uploadText}}
          </div>
        </div>
        <div class="submit" @click='submit'>{{getIndexData.fixedFieldMap['joinUs.submit']}}</div>
      </div>
      <div class="pic">
        <img src="http://p1.music.126.net/sTvX7sOt2bbVhAB60MnWYg==/109951164121065677.jpg?param=140y140" alt="">
        <div class="des">
          <div class="item">
            <i class="iconfont icon-dianhua-copy-copy"></i>
            <!--            <span>联系电话: 020-22116289</span>-->
            <span>{{getIndexData.fixedFieldMap['joinUs.contactNumber']}}: {{contactInformationPhone}}</span>
          </div>
          <div class="item">
            <i class="iconfont icon-dianhua-copy-copy"></i>
            <!--            <span>公司邮箱:  hengdezixun@hornlaw-firm.com</span>-->
            <span>{{getIndexData.fixedFieldMap['joinUs.email']}}: {{contactInformationEmail}}</span>
          </div>
          <div class="item">
            <i class="iconfont icon-dianhua-copy-copy"></i>
            <!--            <span>公司地址: 广东省广州市天河区珠江新城海安路13号越秀财富世纪广场A1栋907室(广州总所)</span>-->
            <span>{{getIndexData.fixedFieldMap['joinUs.address']}}: {{contactInformationAddress}}</span>
          </div>
        </div>
      </div>
    </div>
    <iframe ref='if' class="iframe" src="http://47.107.175.123:8099/horn/map" frameborder="0"></iframe>

    <input ref='file' type="file" style='display: none;' @change='change'>
  </div>
</template>


<script>

  import {mapGetters} from "vuex";

  let ORIGIN_UPLOAD_TEXT = ''
  let SUCCESS_UPLOAD_TEXT = '已上传'

  export default {
    data: () => ({
      inputName: '',
      inputContent: '',
      uploadText: '',
      contactInformationPhone: "",
      contactInformationAddress: "",
      contactInformationEmail: "",
      uploadSrc:"",
      langType:'zh'
    }),
    computed: {
      ...mapGetters(['getIndexData'])
    },
    created() {
      console.log(
        this.getIndexData
      )
      this.uploadText = this.getIndexData.fixedFieldMap['joinUs.uploadFile']
      this.langType = localStorage.getItem('langType')
      let label=[]
      if(this.langType=='zh'){
        label=['phone','address','email']
      }else{
        label=['phoneEn','addressEn','emailEn']
      }
      this.contactInformationPhone = this.getIndexData.contactInformation[1][label[0]].split(",")[0];
      this.contactInformationAddress = this.getIndexData.contactInformation[1][label[1]].split(",")[0];
      this.contactInformationEmail = this.getIndexData.contactInformation[1][label[2]];

    },
    methods: {
      uploadResume() {
        this.$refs.file.click()
      },

      change(file) {
        let f = new FormData
        f.append('file', file.target.files[0])
        this.$$$api.file(f).then(res => {
          this.uploadSrc = res.data.url
          this.uploadText = SUCCESS_UPLOAD_TEXT
        })
      },

      submit() {
        this.$$$api.submit({
          position: this.inputName,
          requirements: this.inputContent,
          url: this.uploadSrc,
        }).then(() => {
          this.inputName = ''
          this.inputContent = ''
          this.uploadText = ORIGIN_UPLOAD_TEXT
          this.uploadSrc = null
          alert('提交成功, 请勿重复提交')
        })
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~styl/mixin.styl"

  theme = #f7aa05

  .talent
    mt(20)

    .iframe
      mt(120)
      ww()
      h(400)

    .input
      ppr()

      .pic
        ppa()
        hh()
        w(600)
        bg(green)
        right 0
        top 0

        .des
          ppa()
          bottom 0
          pb(15)
          pt(30)
          ww()
          bg(rgba(120, 101, 147, .9))
          box()
          pl(40)

          .item
            pt(5)
            pb(5)

            i
              fs(23)
              c(theme)
              c(theme)
              va(middle)

            span
              va(middle)
              c(#fff)
              fs(14)
              pl(10)

        img
          wh()

      .form
        mt(50)
        width 40%

        .input-item
          mb(20)

          .name
            c(theme)
            fs(14)
            pb(5)

          input
            h(30)
            w(450)
            fs(13)

          textarea
            fs(13)
            w(450)
            h(100)
            resize none

        .submit
          &:hover
            cursor pointer
          ta(center)
          lh(40)
          bg(theme)
          w(450)
          c(#fff)
          fs(13)
          mt(25)

        .uploadBtn
          h(40)
          w(450)

          .btn
            ta(center)
            hh()
            lh(40)
            w(250)
            bg(rgb(120, 101, 147))
            fs(13)
            c(#fff)

            &:hover
              cursor pointer

          .uploadImg
            float right
            hh()
            w(60)

            img
              wh()


</style>



// WEBPACK FOOTER //
// src/components/join/talent.vue